import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import CustomSelect from 'components/CustomSelect/CustomSelect';
import AddPaymentMethodButton from 'components/PaymentMethods/AddPaymentMethodButton';
import { useUserInfoContext } from 'components/UserInfoProvider/UserInfoProvider';

const ADD_PAYMENT_METHOD_VALUE = '__add_payment_method__';

const useStyles = makeStyles((theme) => ({
  addPaymentMethod: {
    borderTop: `1px solid ${theme.palette.divider}`,
    color: theme.palette.orange.main,
    fontWeight: 600,
  },
}));

interface Props {
  labelText?: string;
  inputProps?: any;
}

const PaymentMethodSelector: React.FC<Props> = ({
  labelText = 'Choose Payment Method',
  inputProps = {},
}) => {
  const classes = useStyles();
  const { userInfo } = useUserInfoContext();
  const [addPaymentMethodOpen, setAddPaymentMethodOpen] = React.useState(false);

  React.useEffect(() => {
    if (inputProps.value) return;

    // If no initial payment method id is set, set it to the default payment method the user has
    const defaultPaymentMethodId = userInfo?.agentInfo?.stripe?.paymentMethods?.find((o: any) => o.isDefault)?.id;
    if (defaultPaymentMethodId && inputProps.onChange) {
      inputProps.onChange({
        target: {
          id: inputProps.id,
          name: inputProps.name,
          value: defaultPaymentMethodId,
        },
      });
    }
  }, [inputProps.id, inputProps.name, inputProps.onChange, inputProps.value, userInfo]);

  const handleChange = (event: any) => {
    if (event.target.value === ADD_PAYMENT_METHOD_VALUE) {
      setAddPaymentMethodOpen(true);
      return;
    }
    if (inputProps.onChange) inputProps.onChange(event);
  };

  const handlePaymentMethodSaved = (paymentMethodId: string) => {
    if (inputProps.onChange) {
      inputProps.onChange({
        target: {
          id: inputProps.id,
          name: inputProps.name,
          value: paymentMethodId,
        },
      });
    }
  };

  const paymentMethodItems = userInfo?.agentInfo?.stripe?.paymentMethods?.map((pm: any) => ({
    value: pm.id,
    name: `${pm.brand?.toUpperCase()} ending in ${pm.last4} - Expires ${pm.expMonth?.toString().padStart(2, '0')}/${pm.expYear}`,
  })) ?? [];

  return (
    <>
      <CustomSelect
        labelText={labelText}
        items={[
          ...paymentMethodItems,
          { value: ADD_PAYMENT_METHOD_VALUE, name: '+ Add Payment Method', className: classes.addPaymentMethod },
        ]}
        inputProps={{
          ...inputProps,
          onChange: handleChange,
        }}
      />
      <AddPaymentMethodButton
        hideTrigger
        modalControlled
        modalOpen={addPaymentMethodOpen}
        onModalOpenChange={setAddPaymentMethodOpen}
        onSaved={handlePaymentMethodSaved}
      />
    </>

  );
};

export default PaymentMethodSelector;
